import { createFileRoute } from '@tanstack/react-router';
import { generateValidateSearch } from '@/lib/filters/validate-search';
import { FAVOURITES_ROUTE_CONFIG } from '@/pages/Favourites/FavouritesPage.config';

// Was `(search) => search` — a pass-through that validated nothing, because the page's search
// term lived in component state and never reached the URL. Now the schema comes from the same
// config the page renders from, so a param the route does not declare is stripped.
export const Route = createFileRoute('/favourites/')({
  validateSearch: generateValidateSearch(FAVOURITES_ROUTE_CONFIG),
});
